import React from 'react';
import { CheckSquare } from 'lucide-react';

const AdditionalParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <CheckSquare className="w-5 h-5 mr-2 text-green-500" />
        Дополнительные параметры
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Пополнение вклада */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="additionalContributions"
              checked={formData.additionalContributions}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Пополнение вклада
            </span>
          </label>
        </div>

        {/* Частичные снятия */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="withdrawals"
              checked={formData.withdrawals}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Частичные снятия
            </span>
          </label>
        </div>

        {/* Досрочное закрытие */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="earlyTermination"
              checked={formData.earlyTermination}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Досрочное закрытие вклада
            </span>
          </label>
          {formData.earlyTermination && (
            <div className="mt-2 ml-7">
              <label htmlFor="earlyTerminationMonth" className="block text-sm text-gray-700 dark:text-gray-300 mb-1">
                Месяц закрытия
              </label>
              <input
                type="text"
                id="earlyTerminationMonth"
                name="earlyTerminationMonth"
                value={formData.earlyTerminationMonth}
                onChange={handleInputChange}
                className={`form-input w-full md:w-1/3 ${errors.earlyTerminationMonth ? 'input-error' : ''}`}
                placeholder="Номер месяца"
              />
              {errors.earlyTerminationMonth && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.earlyTerminationMonth}
                </p>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdditionalParametersSection;